module.exports = __webpack_public_path__ + "media/images/emp/itl_logo-ee40f3430bea9fb100f49752c686fbaf.png";